import React, { useEffect, useState, useCallback } from "react";
// import Table from "@mui/material/Table";
// import TableBody from "@mui/material/TableBody";
// import TableCell from "@mui/material/TableCell";
// import TableContainer from "@mui/material/TableContainer";
// import Paper from "@mui/material/Paper";
// import TableHead from "@mui/material/TableHead";
// import TableRow from "@mui/material/TableRow";
import { Box, Button, Divider, Grid, Typography } from "@mui/material";
// import GroupIcon from '@mui/icons-material/Group';
import OnlinePredictionIcon from "@mui/icons-material/OnlinePrediction";
import HistoryIcon from "@mui/icons-material/History";
import CircularProgress from "@mui/material/CircularProgress";
import { getUser } from "../../Model/LocalStorage";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";
import { postUndo, hallBid } from "../../Model/DeclaratorModel";
import AccountBalanceIcon from "@mui/icons-material/AccountBalance";
import PhoneInTalkIcon from "@mui/icons-material/PhoneInTalk";
import GridViewIcon from "@mui/icons-material/GridView";
import DesktopWindowsIcon from "@mui/icons-material/DesktopWindows";
import StayCurrentPortraitIcon from "@mui/icons-material/StayCurrentPortrait";
import useMediaQuery from "@mui/material/useMediaQuery";
import NotificationsIcon from "@mui/icons-material/Notifications";
import Chat from "../../auctionsRoom/auctions/chat";
import Drawer1 from "../../auctionsRoom/auctions/drawer";
import "../../auctionsRoom/auctions/chat.css";
import { getMessageStorage } from "../../Model/LocalStorage";
import MessageIcon from "@mui/icons-material/Message";
import { SettingsCellSharp } from "@mui/icons-material";

const TableUserOnline = ({
  socketDeclarator,
  userOnline,
  LiveData,
  messageData,
}) => {
  const phoneMatch = useMediaQuery("(min-width:1200px)");
  const [uniqueArr, setUniqueArr] = useState([]);
  const [bidder, setBidder] = useState([]);
  const [userID, setUserId] = useState("");
  const [hammer, setHammer] = useState("");
  const [author, setAuthor] = useState([]);
  const [username, setUsername] = useState("");
  const [userIDDD, setUserIDDD] = useState("");

  const handleHallBid = () => {
    try {
      //setLoading(true);
      async function postHallBid() {
        const bidData = {
          auction_id: LiveData.auction_details.auction_id,
          setId: LiveData.auction_details.id,
          lot_number: LiveData.lot.details[0].lot_number,
        };

        const results = await hallBid(bidData);
        // setLoading(false);
        if (results.success === true) {
          socketDeclarator.emit("send_Bid_amount", { status: results.success });
        } else if (results.success === false) {
          alert(`Error !: ${results.msg}`);
        } else {
          // alert(results.msg);
        }
      }
      postHallBid().catch((error) => {
        // setLoading(false);
        console.log(error);
      });
    } catch (error) {}
  };

  const handleClickUndo = (val) => {
    const dataArray = {
      auction_id: LiveData.auction_details.auction_id,
      setId: LiveData.auction_details.id,
      lot_number: LiveData.lot.details[0].lot_number,
      bid_history_id: val,
    };

    try {
      async function functionUndo() {
        const results = await postUndo(dataArray);
        //  console.log(":results declarator: ",results)
        if (results.success === true) {
          socketDeclarator.emit("send_status", {
            status: results.success,
            message: "undo",
          });
        } else {
          alert(results.msg);
        }
        // console.log("functionUndo: ", results);
      }
      functionUndo().catch(console.error);
    } catch (error) {}
  };


  const [messageList, setMessageList] = useState({
    messages: [],
    unread: false,
  });
  const [isSupportChatOpen, setIsSupportChatOpen] = useState(false);

  const [chatMessage,setchatMessage] = useState([])
  // const [messageList, setMessageList] = useState([]);

  //   socketDeclarator.brocas("receive_message", (data) => {
  //     console.log('receive_message')
  //   setMessageList((list) => [...list, data]);
  // });
  useEffect(() => {
    // socketDeclarator.on("receive_bid_amount", (data) => {
    //   ListData()
    // })
    // socketDeclarator.on("disconnect", (userId) => {
    //   ///alert("another user in")
    //   setUserOnline(Object.values(userId.userId));
    // });

    try {
      setHammer(LiveData.lot.details[0].hp);
    } catch (error) {}
    async function getUserList() {
      const getuser = await getUser();

      setUserId(getuser.id);
    }
    getUserList().catch(console.error);


    setUniqueArr([...new Set(userOnline)]);
    setBidder(LiveData.bid_history === undefined ? [] : LiveData.bid_history);
    //setHammer(LiveData.lot.details[0].hp);

    socketDeclarator.on("receive_messageDeclarator", (data) => {
    

      // const withoutId1 = userOnline.filter(item => item.userId !== userID);
      // data.filter((x) => x.sender === userID).length === 0 ? 

      // console.log('userOnline' ,withoutId1)
      const text = data.message;
      setchatMessage((list) => [...list, data])

      setMessageList(prev => ({
        ...prev,
        messages: [...prev.messages, { text }],
        unread: !isSupportChatOpen, // only mark unread if chat is closed
      }));



      // setUserOnline(Object.values(userId.userId));
      });


      

      return () => {
        socketDeclarator.off('receive_messageDeclarator');
      };


    // return () => {
    //   socketDeclarator.removeAllListeners();
    // };
  }, [socketDeclarator, userOnline, LiveData,messageData]);


  const [datamessage, setDatata] = useState([])

  // useEffect(() => {
  //   setDatata(messageData)

  // },[messageData]);

  const [open, setOpen] = React.useState(true);
  const [clear, setClear] = React.useState(false);
  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(!open);
    setClear(!clear)
  };

  const handleopen = ((userID, email) => {
    setClear(!clear)
    setOpen(true)
    // 

    // console.log(m    // setMessageList(prevChats =>
    //   prevChats.map(chat =>
    //     chat.sender === userID ? { ...chat, unread: false } : chat
    //   )
    // );essageList?.filter((x) => x.sender === userID))
    setIsSupportChatOpen(true);


    const withoutId1 = chatMessage.filter(item => item.sender !== userID);

    setchatMessage(withoutId1)
    // setMessageList(prev => ({
    //   ...prev,
    //   unread: false, // clear the notification
    // }));
    
    setUserIDDD(userID);
    setUsername(email);
    setOpen(!open);
  });

  return (
    <div>
            <Divider></Divider>
      <Box style={{ padding: 10 }}>
        <Grid container spacing={2} style={{marginTop: '-10px',
    width: 'calc(100% + 20px)',
    marginLeft: '-10px'}}>
          <Grid item xs={phoneMatch === true ? 5 : 12} style={{border: '.5px solid rgb(225 220 220)',paddingLeft: 0}}>
            <Box >


            <div
              style={{
                paddingBottom: 10,
                display: "flex",
                justifyContent: "space-between",
              }}
            >
              <Typography style={{ fontWeight: "bold" ,marginLeft: 15}}>
                <OnlinePredictionIcon /> Online :
                <b
                  style={{
                    backgroundColor: "#12bc12",
                    color: "white",
                    padding: " 5px 10px",
                    borderRadius: 5,
                    marginLeft: 10,
                  }}
                >
                  {uniqueArr.length}
                </b>
              </Typography>
              <Typography> </Typography>
            </div>
     <Divider/>
            </Box>
            <Box
              style={{
                display: "flex",
                background: "white",
                justifyContent: "space-between",
              }}
            >
              <List
                style={{
                  width: "100%",
                  bgcolor: "background.paper",
                  position: "relative",
                  overflow: "auto",
                  maxHeight: 285,
                  // overflow: "auto",
                  // height:300,
                  flexDirection: "column-reverse",
                  display: "-webkit-inline-flex",
                  // "& ul": { padding: 0 },
                }}
              >
                {uniqueArr.length ? ( uniqueArr.map((season, index) => {
                
                    return (
                      <ListItem
                        key={index}
                        style={{ paddingBottom: 0, paddingTop: 0 }}
                      >
                        <ListItemText
                          // gutterBottom
                          align="left"
                          primary={
                            <React.Fragment>
                              <Typography
                                onClick={() =>
                                  handleopen(season.userId, season.email)
                                }
                                style={{
                                  fontSize: 14,
                                  cursor: 'pointer'
                                }}
                                variant="body2"
                                color="text.primary"
                              >
                                {season.mobile === undefined ? (
                                  ""
                                ) : season.mobile === true ? (
                                  <StayCurrentPortraitIcon fontSize="small" />
                                ) : (
                                  <DesktopWindowsIcon fontSize="small" />
                                )}

                                {season.email}
                                <div class="buttonss">
                                  <MessageIcon
                                    style={{ color: "black", cursor: 'pointer' }}
                                    fontSize="small"
                                  />

                                  
{messageList.unread && (
 <span className={ chatMessage.filter((x) => x.sender === season.userId).length  === 0 ? "":"button__badge"}>                          
                                    { chatMessage.filter((x) => x.sender === season.userId).length}
                                  </span> )}
                                </div>
                              </Typography>
                            </React.Fragment>
                          }
                        />
                      </ListItem>
                    );
                  })
                ) : (
                  <Box
                    sx={{ display: "flex", marginLeft: "45%", marginTop: 5 }}
                  >
                    <CircularProgress />
                  </Box>
                )}
              </List>
            </Box>
          </Grid>

          <Grid item xs={phoneMatch === true ? 7 : 12} style={{border: '.5px solid rgb(225 220 220)',paddingLeft: 0, background: "rgb(248 248 248)",}}>
            <div >
              <div
                style={{
                  paddingBottom: 10,
                  display: "flex",
                  justifyContent: "space-between",
                }}
              >
                <Typography style={{ fontWeight: "bold" ,marginLeft: 15}}>
                  <HistoryIcon /> Bid History :
                </Typography>
                {/* <Divider/> */}
              </div>
              <Divider />
              <Box
                style={{
                  display: "flex",
                  background: "white",
                  justifyContent: "space-between",
                }}
              >
                <List
                  style={{
                    width: "100%",
                    background: "rgb(248 248 248)",
                    position: "relative",
                    overflow: "auto",
                    height:300,
                    flexDirection: "column-reverse",
                    // display: "-webkit-inline-flex",
                    // "& ul": { padding: 0 },
                  }}
                >
                  {bidder.length ? (
                    bidder.map((val, index) => {
                      return (
                        <ListItem
                          key={index}
                          style={{ paddingBottom: 0, paddingTop: 0 }}
                        >
                          <ListItemText
                            // gutterBottom
                            align="left"
                            primary={
                              <React.Fragment>
                                <Typography
                                  style={{
                                    fontSize:  val.win_status === "WIN" ? 15:12,
                                    color:  val.win_status === "WIN" ? 'green':'',
                                    fontWeight:  val.win_status === "WIN" ? 'bold':'',
                                  }}
                                  variant="body2"
                                  color="text.primary"
                                >
                                  {val.email}
                                </Typography>
                              </React.Fragment>
                            }
                          />
                          <Box style={{ width: 100 }}>
                            {/* <ListItemText
                          gutterBottom
                          align="left"
                          primary={
                            <React.Fragment>
                              <Typography
                                style={{
                                  fontSize: 12,
                               
                                }}
                                variant="body2"
                                color="text.primary"
                              >
                                {val.bidder_type}
                              </Typography>
                            </React.Fragment>
                          }
                        />  */}
                          </Box>
                          <ListItemText
                            align="right"
                            // gutterBottom
                            primary={
                              <React.Fragment>
                                {(userID === val.userId &&
                                  val.hammer === hammer &&
                                  val.bidder_type === "FLOOR BIDDER") ||
                               
                                (val.bidder_type === "TELEPHONE BIDDER" &&
                                  val.win_status === "WIN") ? (
                                  <Button
                                    fullWidth
                                    variant="contained"
                                    style={{
                                      background:
                                        val.bidder_type === "FLOOR BIDDER"
                                          ? "red"
                                          : "green",
                                      color: "white",
                                    }}
                                    onClick={() =>
                                      handleClickUndo(val.bid_history_id)
                                    }
                                    startIcon={
                                      val.bidder_type === "FLOOR BIDDER" ? (
                                        <GridViewIcon />
                                      ) : (
                                        <PhoneInTalkIcon />
                                      )
                                    }
                                    // className={`${classes.buttonGray} ${classes.ButtonCustom}`}
                                  >
                                    {/* {val.bidder_type === "FLOOR BIDDER" ? "Floor Bid": "Phone Bid"} */}
                                    {"Php " + val.hammer.toLocaleString()}
                                  </Button>
                                ) :  val.hammer === hammer &&  val.win_status === "WIN" ?    val.bidder_type === "INTERNET BIDDER" ||  val.bidder_type === "ABSENTEE BIDDER"  ? <Typography
                                style={{
                                  fontSize: 15,
                                }}
                                variant="body2"
                                // color="text.primary"
                              >   {"Php " + val.hammer.toLocaleString()}</Typography>:
                                 (<div
                                     style={{
                                      backgroundColor: 'rgb(24 118 210)',
                                      border: 'none',
                                      color: 'white',
                                      padding: '5px 15px',
                                      textAlign: 'center',
                                      textDecoration: 'none',
                                      display: 'inline-block',
                                      // fontSize: 16,
                                      // margin: '4px 2px',
                                      borderRadius: 5,
                                      cursor: 'pointer'
                                     }}
                                      variant="contained"
                                      color="primary"
                                      onClick={(e) => handleHallBid(e)}
                                      startIcon={<AccountBalanceIcon />}
                                      // className={`${classes.buttonGray} ${classes.ButtonCustom}`}
                                    >
                                      <Typography
                                          style={{
                                            fontSize: 15,
                                          }}
                                          variant="body2"
                                          // color="text.primary"
                                        >   {"Php " + val.hammer.toLocaleString()}</Typography>
                                   
                                       </div>
                        
                                ) : (
                                  <Typography
                                    style={{
                                      fontSize: 12,
                                    }}
                                    variant="body2"
                                    color="text.primary"
                                  >
                                    {" "}
                                    {"Php " + val.hammer.toLocaleString()}
                                  </Typography>
                                )}
                              </React.Fragment>
                            }
                          />
                        </ListItem>
                      );
                    })
                  ) : (
                    // <Box
                    //   sx={{ display: "flex", marginLeft: "45%",  }}
                    // >
                    //   <CircularProgress />
                    // </Box>
                    <ListItemText
                      gutterBottom
                      align="left"
                      primary={
                        <React.Fragment>
                          <Typography
                            style={{
                              fontSize: 15,
                              textAlign: "center",
                            }}
                            variant="body2"
                            color="text.primary"
                          >
                            No Records Found
                          </Typography>
                        </React.Fragment>
                      }
                    />
                  )}
                </List>
              </Box>
              
            </div>
          </Grid>
        </Grid>
        <Divider></Divider>
      </Box>

      <div
        style={{
          position: "fixed",
          bottom: "-200px",
          borderRadius: 5,
          cursor: "pointer",
          zIndex: 99999,
          margin: phoneMatch === true ? 5 : 0,
        }}
        open={true}
        onClose={handleClose}
      >
        <div
          onClick={handleClose}
          style={{
            // position: "absolute",
            background: "#2459c9",
            color: "white",
            width: 60,
            height: 60,
            right: 16,
            // padding: 2,
            borderRadius: 60,
            textAlign: "center",
            fontSize: 20,
            lineHeight: "55px",
            display: open === true ? "block" : "none",
            // padding:"px 3px 0 3px"
          }}
        >
          {/* <SensorsIcon /> */}

          <MessageIcon style={{ fontSize: 35 }} />
        </div>
      </div>

      <div
        style={{
          position: "relative",
          bottom: 200,
          zIndex: 9999,
          display: open === false ? "block" : "none",
        }}
      >
        <div style={{ position: "absolute",   left: 0, top: '-230px'}}>
          <Drawer1
             status={open}
            socket={socketDeclarator}
            username={username}
            room={userIDDD}
            handleClose={handleClose}
            sender={userIDDD}
          />
        </div>
      </div>
    </div>
  );
};

export default TableUserOnline;
